import React, { useState, useEffect } from 'react';
import { assest } from '../Assest/Assest';

const InvisalignOffer = () => {
  const [showOffer, setShowOffer] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOffer(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!showOffer) return null;

  const openWhatsApp = () => {
    const message = encodeURIComponent('Hello! I am interested in booking an Invisalign consultation. Can you provide more details?');
    const phoneNumber = '919698704907';
    const whatsappUrl = `https://wa.me/${phoneNumber}/?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '10px',
      }}
      onClick={() => setShowOffer(false)}
    >
      <div
        style={{
          position: 'relative',
          width: '90%',
          maxWidth: '400px',
          padding: '20px',
          backgroundImage: `url("https://media.istockphoto.com/id/1439181126/photo/transparent-plastic-braces-lie-in-a-row-with-each-other-creating-a-pattern-on-a-blue.jpg?s=612x612&w=0&k=20&c=3q3EBkK8Awa4aNUKOLkm4Ws1m_RUHKFmZYa8tpF7Q5I=")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: '#CADCFC',
          textAlign: 'center',
          borderRadius: '10px',
          fontFamily: 'Arial, sans-serif',
          boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.3)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setShowOffer(false)}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'red',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '30px',
            height: '30px',
            cursor: 'pointer',
            fontSize: '1.2rem',
          }}
        >
          ×
        </button>
        <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#00246B' }}>Flat 20% OFF on Invisalign!</h2>
        <img 
          src={assest.invilogo} 
          alt="Invisalign Logo" 
          style={{ width: '70%', maxWidth: '200px', margin: '10px auto', display: 'block' }}
        />
        <p style={{ fontSize: '1rem', margin: '10px 0', color: '#00246B', fontWeight: '800' }}>
          Achieve your perfect smile today.
        </p>
        <button
          onClick={openWhatsApp}
          style={{
            backgroundColor: '#00246B',
            color: '#CADCFC',
            padding: '12px 18px',
            fontSize: '1rem',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginTop: '10px',
            width: '100%',
            maxWidth: '250px',
            fontWeight: '700',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          Order Now
        </button>
      </div>
    </div>
  );
};

export default InvisalignOffer;
